import { IVideo } from "~/types/video";

export const videos: IVideo[] = [
  {
    url: "//fast.wistia.net/embed/iframe/x1i0j6i5ns",
    titleKey: "video.overview",
    time: "0:47",
  },
];
